import React from 'react'

import { Portlet, Row, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'
import * as IslaCombustibleService from 'services/islaCombustible.service'

import RowTemplate from './rowTemplate'

const IslaControl = () => {
  const [islasActivas, setIslasActivas] = React.useState([])
  const [combustiblesxIsla, setCombustiblesxIsla] = React.useState([])

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSoloLectura(TiposTablaPersonalizadaConstant.ISLAGRIFO, true).then(({ data }) => {
      setIslasActivas(data)
    })

    IslaCombustibleService.obtenerAsIslaControl().then(({ data }) => {
      setCombustiblesxIsla(data)
    })
  }, [])

  const refrescarCombustiblexIsla = React.useCallback(() => {
    IslaCombustibleService.obtenerAsIslaControl().then(({ data }) => {
      setCombustiblesxIsla(data)
    })
  }, [])

  return (
    <Portlet>
      <Portlet.Header title='Islas Control' />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <table border='1' width='100%'>
              <thead>
                <tr>
                  <th>ISLA</th>
                  <th>LADO</th>
                  <th
                    style={{
                      width: '270px'
                    }}
                  >
                    COMBUSTIBLE
                  </th>
                </tr>
              </thead>
              <tbody>
                {islasActivas.map(x => (
                  <RowTemplate
                    key={x._id}
                    infoIsla={x}
                    combustiblesxIsla={combustiblesxIsla.filter(y => y._idIsla === x._id)}
                    refrescarCombustiblexIsla={refrescarCombustiblexIsla}
                  />
                ))}
              </tbody>
            </table>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(IslaControl)
